/* eslint-disable no-extend-native */
import padStart from 'string.prototype.padstart/implementation';

(() => {
  if (!String.prototype.padStart) String.prototype.padStart = padStart;
})();
